// Custom code: tiers

import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class PricingTiers extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.querySelector("variant-picker")?.addEventListener(ThemeEvents.variantUpdate, this.#variantChanged.bind(this))
  }

 
  #variantChanged(event) {
    const {html} = event.detail.data
    const newInnerHTML = html.querySelector(`pricing-tiers`)?.innerHTML;
    this.innerHTML = newInnerHTML

  }
}

if (!customElements.get('pricing-tiers')) {
  customElements.define('pricing-tiers', PricingTiers);
}
